if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      // Scope the checkbox to THIS instance (cart page or drawer, not both)
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;

      // Find the cart container we belong to (cart page form or drawer)
      const scope = this.closest('form') || this.closest('sidebar-drawer') || this.closest('.cart-page') || document;

      // Standard checkout button(s) within our scope
      this.checkoutButtons = scope.querySelectorAll('button[name="checkout"], #CheckOut');

      // Dynamic / additional checkout buttons (Shop Pay, PayPal, Apple Pay, GPay)
      this.additionalButtonsWrappers = scope.querySelectorAll('.additional-checkout-buttons, .shopify-payment-button');

      this.checkbox.addEventListener('change', () => this.update());
      this.update();

      // Click-block on dynamic checkout buttons when unchecked (capture phase, prevents iframe clicks too)
      this.additionalButtonsWrappers.forEach(wrap => {
        wrap.addEventListener('click', (e) => {
          if (!this.checkbox.checked) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.flashCheckbox();
          }
        }, true);
      });
    }

    update() {
      const checked = this.checkbox.checked;

      this.checkoutButtons.forEach(btn => {
        btn.disabled = !checked;
        btn.classList.toggle('is-disabled-by-terms', !checked);
      });

      this.additionalButtonsWrappers.forEach(wrap => {
        wrap.classList.toggle('is-disabled-by-terms', !checked);
        // Set inert to fully block keyboard/screen-reader interaction (modern browsers)
        if ('inert' in HTMLElement.prototype) wrap.inert = !checked;
      });
    }

    flashCheckbox() {
      const label = this.querySelector('label') || this;
      label.classList.add('terms-flash');
      setTimeout(() => label.classList.remove('terms-flash'), 600);
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
